import { MONTH_NAMES_CA } from './constants';

const currencyFormatter = new Intl.NumberFormat('ca-ES', {
    style: 'currency',
    currency: 'EUR',
});

const dateFormatter = new Intl.DateTimeFormat('ca-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
});

const dateTimeFormatter = new Intl.DateTimeFormat('ca-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
});

export function normalizeDate(dateValue) {
    if (!dateValue) {
        return null;
    }

    if (dateValue instanceof Date) {
        return Number.isNaN(dateValue.getTime()) ? null : dateValue;
    }

    const normalizedValue = String(dateValue).includes(' ')
        ? String(dateValue).replace(' ', 'T')
        : String(dateValue);
    const date = new Date(normalizedValue);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(dateValue, includeTime = false) {
    const date = normalizeDate(dateValue);
    if (!date) {
        return '-';
    }

    return includeTime ? dateTimeFormatter.format(date) : dateFormatter.format(date);
}

export function formatCurrency(value) {
    const amount = Number.isFinite(Number(value)) ? Number(value) : 0;
    return currencyFormatter.format(amount);
}

function roundMoney(value) {
    return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
}

export function calculateBillingPeriodTotal(monthlyBaseAmount, cadence) {
    const normalizedCadence = String(cadence || '').trim().toLowerCase();
    const monthsInPeriod = normalizedCadence === 'annual' ? 12 : 1;
    const unitBaseAmount = Number.isFinite(Number(monthlyBaseAmount)) ? Number(monthlyBaseAmount) : 0;
    const baseAmount = roundMoney(unitBaseAmount * monthsInPeriod);
    const vatAmount = roundMoney(baseAmount * 0.21);
    const withholdingAmount = roundMoney(baseAmount * 0.07);

    return roundMoney(baseAmount + vatAmount - withholdingAmount);
}

export function formatPeriodLabel(record) {
    const cadence = String(record?.periodKey || '').split(':')[0];
    const periodStart = normalizeDate(record?.periodStart);
    const periodEnd = normalizeDate(record?.periodEnd);

    if (periodStart && cadence === 'monthly') {
        return `${MONTH_NAMES_CA[periodStart.getMonth()]} ${periodStart.getFullYear()}`;
    }

    if (periodStart && cadence === 'annual') {
        return `Anual ${periodStart.getFullYear()}`;
    }

    if (periodStart && periodEnd) {
        return `${formatDate(periodStart)} - ${formatDate(periodEnd)}`;
    }

    return record?.periodKey || '-';
}
